import { render } from "./Excluir.vue?vue&type=template&id=a2e0e866"
const script = {}
script.render = render

export default script